export const focusTasklistTextarea = (id: string): void => {
  const currentTasklist = document.querySelector(
    `[data-id="${id}"]`
  ) as HTMLElement;
  if (currentTasklist) {
    const textarea = currentTasklist.querySelector('textarea');
    textarea?.focus();
  }
};
